import Vue from 'vue'

const Global = {
  namespaced: true,

  state: {
    account: {},
    config: {},
    version: {},
    snackbar: false,
    snackbarColor: null,
    snackbarText: null
  },

  mutations: {
    setSnackbar(state, snackbar) {
      state.snackbarColor = snackbar.color || 'success'
      state.snackbarText = snackbar.text || null
      state.snackbar = !!snackbar.text
    },
    setAccount(state, account) {
      state.account = account || {}
    },
    setConfig(state, config) {
      state.config = config || {}
    },
    setVersion(state, version) {
      state.version = version
    }
  },

  actions: {
    async getAccount({ commit }) {
      const response = await Vue.axios.get('/account')
      const account = response.data.data
      commit('setAccount', account)
      return account
    },
    async getVersion({ commit }) {
      const { data } = await Vue.axios.get('/')
      commit('setVersion', data)
    },
    async getConfig({ commit }) {
      const response = await Vue.axios.get('/config')
      const config = response.data.data
      commit('setConfig', config)
    },
    async updateConfig({ commit, state }) {
      const response = await Vue.axios.put('/config', state.config)
      const config = response.data.data
      commit('setConfig', config)
    }
  }
}

export default Global
